// extracted by mini-css-extract-plugin
export var aboveInput = "_nn-0";
export var actionButton = "_nn-5";
export var actionButtonContainer = "_nn-1";
export var actionIcon = "_nn-6";
export var aiInfoContainer = "_nn-2";
export var attachmentWrapper = "_nn-7";
export var bold = "_nn-3";
export var checkIcon = "_nn-8";
export var clickingRecipientBar = "_nn-11";
export var commentThreadSwitch = "_nn-a";
export var draftImage = "_nn-b";
export var draftImageContainer = "_nn-c";
export var draftImages = "_nn-e";
export var editButton = "_nn-g";
export var editor = "_nn-f";
export var editorContainer = "_nn-y";
export var editorErrorTooltipWrapper = "_nn-9";
export var headerDivider = "_nn-h";
export var icon = "_nn-i";
export var info = "_nn-j";
export var internal = "_nn-n";
export var internalDivider = "_nn-k";
export var internalMessage = "_nn-l";
export var messageInputCard = "_nn-m";
export var messageInputForm = "_nn-o";
export var messageInputFormInternal = "_nn-p";
export var options = "_nn-q";
export var publicMessageCustomer = "_nn-s";
export var publicMessageMerchant = "_nn-r";
export var removeImageButton = "_nn-d";
export var replyButtons = "_nn-t";
export var showSignatureButton = "_nn-u";
export var spinner = "_nn-v";
export var verticalButtonDivider = "_nn-4";
export var visibilitySelector = "_nn-w";
export var warning = "_nn-x";
export var wrappingText = "_nn-z";
export var writingInternalNoteTopBorder = "_nn-10";